<template>
  <a :href="href" 
     :target="item.target || '_self'" 
     :class="classArgs" 
     :data-toggle="dataToggle">
        <span :class="{ 'border-placeholder': border }">{{ item.display }}</span>
  </a>
</template>

<script>
  import activeRoute from "../mixins/active-route";

  export default {
    name: "menu-item",
    props: {
      item: Object,
      iframe: Boolean,
      cssOverride: String,
      border: {
        type: Boolean,
        default: true
      }
    },

    mixins: [activeRoute],

    computed: {

      dataToggle() {
        return this.hasChildren ? "dropdown" : "";
      },

      classArgs() {
        return this.cssOverride ?? {
          'nav-link': true,
          active: this.activeRoute,
          "dropdown-toggle": this.hasChildren
        };
      },

      hasChildren() {
        return this.item.children?.length > 0;
      },

      href() {
        let route;
        if (!this.hasChildren) {
          if (this.item.routeType === "static") {
            route = this.item.path;
          } else {
            route = this.item.path === "/" ? "/" : `/app/${this.item.path}`;
          }

          if (this.iframe) {
            route += "?iframe=1";
          }

        } else {
          route = "javascript:void(0)";
        }
        return route;
      }
    }
  };
</script>